// Generated by yarn alfa-postversion
const version = "0.101.0";
export default version;
//# sourceMappingURL=version.js.map